export default "__VITE_ASSET__32e7ed8a__"